// @flow
import type { EnvironmentConfig } from 'model/EnvironmentConfig';

export default (): EnvironmentConfig => ({
  atlAdminUrl: 'https://admin.stg.atlassian.com',
  clicktaleEnabled: true,
  hamsUrl: 'https://wac.stg.internal.atlassian.com/hamlet',
  idLoginUrl: 'https://id.stg.internal.atlassian.com/login',
  logoutUrl: () =>
    `https://id.stg.internal.atlassian.com/logout?continue=${encodeURIComponent(
      document.location.href,
    )}`,
  marketplaceUrl: 'https://marketplace.stg.internal.atlassian.com',
  padresUrl: 'https://marketplace.stg.internal.atlassian.com/padres',
  paypal: {
    env: 'sandbox',
  },
  segmentKey: 'EWfeqJKJ0rPNOe3fcXrh2dg7bVXZNi2I',
  sentry: {
    debug: true,
    environment: 'stg',
  },
  wacUrl: 'https://wac.stg.internal.atlassian.com',
  wacPurchaseLicensingUrl: 'https://wac.stg.internal.atlassian.com/licensing/purchase-licensing',
  i18nUrl: 'https://cart-static.us-east-1.staging.public.atl-paas.net/i18n',
  cloudMigrationToolsUrl: 'https://api-private.stg.atlassian.com/cloud-migration-tools',
  root: 'https://wac.stg.internal.atlassian.com/purchase',
  partnerPortal: 'https://partners.stg.internal.atlassian.com',
  intercomAppID: 'odnoznr4',
  adminHubUrl: 'https://admin.stg.atlassian.com',
  statsigClientSDK: 'd6e6637d-7fb6-42f3-adf2-b874adb88525',
  emailMAC: (userEmail) =>
    `https://id.stg.internal.atlassian.com/login?application=mac&continue=https://id.stg.internal.atlassian.com/manage-profile&prompt=none&login_hint=${userEmail}`,
  billingDetailsMAC: 'https://wac.stg.internal.atlassian.com/purchase/my/edit-details',
  switchUserMAC: 'https://wac.stg.internal.atlassian.com/purchase/my/config',
  switchAccountMAC:
    'https://id.stg.internal.atlassian.com/login?application=mac&continue=https://wac.stg.internal.atlassian.com/purchase/my&prompt=select_account',
  logOutMAC:
    'https://id.stg.internal.atlassian.com/logout?application=mac&continue=https://wac.stg.internal.atlassian.com/purchase/my',
  calculatePricingURL: 'https://wac.stg.internal.atlassian.com/migration/assess/calculate-pricing',
  ppcUrl: 'https://ppc.stg.atlassian.com',
  companyContact: 'https://wac.stg.internal.atlassian.com/company/contact',
  legalCustomerAgreement: 'https://www.atlassian.com/legal/customer-agreement',
  profileAction: 'https://id.stg.internal.atlassian.com/profile/profile.action',
  support: 'https://support.stg.internal.atlassian.com',
  bitbucketCmtUrl: 'https://integration.bb-inf.net/',
  applicationFormLink: (orgId) =>
    `https://credit-request-ui.stg-east.frontend.public.atl-paas.net/${orgId}?source=HAMS`,
  migrationLink: 'https://www.atlassian.com/migration',
  omniChannelGraphQLUrl: 'https://wac.stg.internal.atlassian.com/gateway/api/graphql',
  omniChannelFlowId: '928ba5ad-5618-4213-874d-e3766b74e784',
  omniChannelEnvironment: 'staging',
});
